/* @flow */
// typecheck: ignore file
import React from 'react';
import BoxBody from 'components/BoxBody.jsx';
import Dialog from 'components/Dialog.jsx';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import Link from 'components/Link.jsx';
import Input from 'components/Input.jsx';
import MediaObject from 'components/MediaObject.jsx';
import minimalRelatedUserFragment from 'user/fragments/minimalRelatedUserFragment.gql';
import ProfilePicture from 'user/components/ProfilePicture.jsx';
import Text from 'components/Text.jsx';

import './styles/AddParentChildModal.scss';

type MinimalRelatedUser = {
  id: number,
  name: string,
  initials: string,
}

type RelatedUserSearchResult = {
  query_key: string,
  user: MinimalRelatedUser,
}

type Props = {
  resultItems: [RelatedUserSearchResult],
  relation: 'parent' | 'child',
  onRequestHide: () => void,
  onAddRelation: () => void,
  addRelation: (parentId: ?number, childId: ?number) => Promise<*>,
  viewingUserId: number,
};

type State = {
  query: string,
}

class AddParentChildModal extends React.Component {
  props: Props;
  state: State;

  state = {
    query: '',
  }

  addExistingParentOrChild = (otherId: number) => {
    const selfId = this.props.viewingUserId;
    const [parentId, childId] = (this.props.relation === 'child') ? [selfId, otherId] : [otherId, selfId];

    this.props.addRelation(parentId, childId)
      .then(this.props.onAddRelation())
      .catch(e => console.error('Adding parent relation failed', e));

    this.props.onRequestHide();
  }

  performSearch = (event: SyntheticEvent) => {
    this.setState({
      // $FlowFixMe
      query: event.target.value,
    });
  }

  renderEmptyQuery() {
    const text = this.props.relation === 'parent' ?
      'Search for your child by first or last name' :
      'Search for your parent by first or last name';

    return (
      <Text
        className="AddParentChildModal-empty-query"
        element="div"
        color="koala"
        size="large">
        {text}
      </Text>
    );
  }

  renderResultListItem(item: RelatedUserSearchResult) {
    const { user } = item;
    return (
      <Link
        key={user.id}
        className="AddParentChildModal-result-item"
        block
        onClick={() => this.addExistingParentOrChild(user.id)}>
        <MediaObject
          className="AddParentChildModal-result-item-inner"
          gutter="small">
          <div>
            <ProfilePicture
              size="medium"
              user={user}
            />
          </div>
          <Text element="div">{user.name}</Text>
        </MediaObject>
      </Link>
    );
  }

  renderResultList() {
    if (this.state.query.length <= 2) {
      return null;
    }

    return this.props.resultItems
      .filter((item) => {
        return item.query_key.includes(this.state.query.toLowerCase());
      })
      .map(this.renderResultListItem, this);
  }

  renderAddPerson() {
    const isParent = this.props.relation === 'parent';
    const h1Text = isParent ? 'Don’t see your child?' : 'Don’t see your parent?';
    const h2Text = isParent ?
      'Your child must be first added to a class so that you can connect them' :
      'Your parent must be first added to a class so that you can connect them';

    return (
      <BoxBody>
        <Text
          size="large"
          element="p">
          {h1Text}
        </Text>
        <Text
          color="thunder"
          element="p">
          {h2Text}
        </Text>
      </BoxBody>
    );
  }

  render() {
    const isParent = this.props.relation === 'parent';
    const placeholderText = isParent ? 'Search for a child' : 'Search for a parent';
    const title = isParent ? 'Add a child' : 'Add a parent';

    return (
      <Dialog
        eventScreenName={this.props.relation === 'parent' ? 'AddChildModal' : 'AddParentModal'}
        className="AddParentChildModal"
        size="small"
        onRequestHide={this.props.onRequestHide}
        title={title}>
        <BoxBody full>
          <div className="AddParentChildModal-input">
            <Input
              autofocus
              glyph="search"
              placeholder={placeholderText}
              onChange={this.performSearch}
            />
          </div>
        </BoxBody>
        <div className="AddParentChildModal-content">
          {!this.state.query.length && this.renderEmptyQuery()}
          {this.renderResultList()}
          {!!this.state.query.length && this.renderAddPerson()}
        </div>
      </Dialog>
    );
  }
}

const withData = graphql(gql`
  query ($relation: String!) {
    potentialFamily(relation: $relation, name: "") {
      query_key
      user {
        ...minimalRelatedUser
      }
    }
  }
  ${minimalRelatedUserFragment}
  `,
  {
    options: ({ relation }) => ({ variables: { relation } }),
    props: ({ data }) => {
      return {
        resultItems: data.potentialFamily ? data.potentialFamily : [],
      };
    },
  }
);

const withMutations = graphql(gql`
  mutation addParent($input: ParentChildInput!) {
    addParentRelationship(parentChildInput: $input) {
      error {
        message
      }
    }
  }
  `, {
    props({ mutate }) {
      return {
        addRelation(parentId: ?number, childId: ?number) {
          const input = {
            parent_id: parentId,
            child_id: childId,
          };
          return mutate({ variables: { input } });
        },
      };
    },
  }
);


export { AddParentChildModal };
export default withMutations(withData(AddParentChildModal));



// WEBPACK FOOTER //
// ./src/settings/components/AddParentChildModal.jsx